import { render, staticRenderFns } from "./MainSolver.vue?vue&type=template&id=1923a548"
import script from "./MainSolver.vue?vue&type=script&lang=js"
export * from "./MainSolver.vue?vue&type=script&lang=js"
import style0 from "./MainSolver.vue?vue&type=style&index=0&id=1923a548&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports